import {useSelector} from 'react-redux';
import {roomSelector, roomUserCountSelector} from '../store/selectors/roomRunFile.selectors';

export interface PresentationMode {
    isRoom: boolean;
    isPresenter: boolean;
    showViewerCount: boolean;
    viewerCount: number;
    showTimer: boolean;
    showPoints: boolean;
    showLeaderboard: boolean;
    hasIdentification: boolean;
    exitModalVariant: 'closeRoom' | 'exitLobby';
}

export function usePresentationMode(): PresentationMode {
    const room = useSelector(roomSelector);
    const viewerCount = useSelector(roomUserCountSelector);

    const isRoom = !!room.roomId;
    const {isPresenter} = room;

    return {
        isRoom,
        isPresenter,
        showViewerCount: isPresenter,
        viewerCount,
        showTimer: isRoom,
        showPoints: !isPresenter,
        showLeaderboard: !!room.showLeaderboard,
        hasIdentification: !!(room.identification?.groupIdentificationOn || room.identification?.specificIdentificationOn),
        exitModalVariant: isPresenter ? 'closeRoom' : 'exitLobby',
    };
}
